/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import { idToDate } from 'common/lib/util/date';
import { usesEnglish } from '@trello/locale';
// eslint-disable-next-line no-restricted-imports
import Token from 'common/lib/util/token';
import { GetMember } from './types';

interface AudienceSettings {
  startDate: string;
}

const activeChannel = (member: ReturnType<GetMember>) => {
  const channels = member ? member.channels : undefined;

  return channels && channels.active;
};

export default function getAudienceDefinitions(getMember: GetMember) {
  return {
    allMembers() {
      return true;
    },

    alphaMembers() {
      return activeChannel(getMember()) === 'alpha';
    },

    englishMembers() {
      return usesEnglish();
    },

    alphaEnglishMembers() {
      return usesEnglish() && activeChannel(getMember()) === 'alpha';
    },

    betaEnglishMembers() {
      return usesEnglish() && activeChannel(getMember()) === 'beta';
    },

    newUsers(settings?: AudienceSettings) {
      const member = getMember();
      const id = member && member.id ? member.id : Token.getMyId();

      if (settings && settings.startDate) {
        return idToDate(id) > new Date(settings.startDate);
      } else {
        throw new Error('Must specify a start date in the test config');
      }
    },

    neededAccountConfirmation() {
      const member = getMember();
      let loginTypes: string[] = [];
      if (member && member.loginTypes) {
        loginTypes = member.loginTypes;
      }

      return loginTypes.includes('password');
    },

    noTeams() {
      const member = getMember();
      let orgs: string[] = [];
      if (member && member.idOrganizations) {
        orgs = member.idOrganizations;
      }

      return orgs.length === 0;
    },

    noBoards() {
      const member = getMember();
      let boards: string[] = [];
      if (member && member.idBoards) {
        boards = member.idBoards;
      }

      return boards.length === 0;
    },

    newAndNeededConfirmationAndNoTeams(settings?: AudienceSettings) {
      return (
        this.newUsers(settings) &&
        this.neededAccountConfirmation() &&
        this.noTeams()
      );
    },

    newAndNoTeams(settings?: AudienceSettings) {
      return this.newUsers(settings) && this.noTeams();
    },

    internalTeams() {
      const member = getMember();

      const idOrganizationsInternal = new Set([
        '58adea146fcdb5f4e50bebf2', // Atlassian
        '538627f73cbb44d1bfbb58f0', // Trello
      ]);

      return (
        member &&
        member.idOrganizations &&
        member.idOrganizations.some((id) => idOrganizationsInternal.has(id))
      );
    },

    newAndNoTeamsAndNoBoards(settings?: AudienceSettings) {
      return this.newUsers(settings) && this.noBoards() && this.noTeams();
    },

    englishAndNewAndNoTeams(settings?: AudienceSettings) {
      return this.englishMembers(settings) && this.newAndNoTeams(settings);
    },

    englishAndNewAndNoTeamsAndNoBoards(settings?: AudienceSettings) {
      return (
        this.englishMembers(settings) && this.newAndNoTeamsAndNoBoards(settings)
      );
    },

    englishAndNew(settings?: AudienceSettings) {
      return this.englishMembers(settings) && this.newUsers(settings);
    },
  };
}



// WEBPACK FOOTER //
// ./app/common/lib/experiments/audience-definitions.ts